import React from "react";
import { Button, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";



function Profile() {

  let getLogin = sessionStorage.getItem('login')
  
    let rStore = useSelector((state)=>{return state})
    let dispatch = useDispatch()
    let navigate = useNavigate()
    
    return(
              <div>
                { getLogin ? <LoginProfile></LoginProfile> : <NoLoginProfile></NoLoginProfile>}                
              </div>      
    )

    function LoginProfile() {
      return(
        <Card style={{ width: '100%' }}>
                {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
                <Card.Body>
                  <Card.Title>{localStorage.getItem('nikname')}</Card.Title>
                  <Card.Text>
                  님 방문을 환영합니다. <br></br>
                  로그인 중인 아이디 : {localStorage.getItem('email')} 
                  </Card.Text>
                  <Button variant="primary" onClick={()=>{navigate('/write')}}
                  style={{float:'right'}}>글쓰기</Button>
                    <Button variant="dark" style={{float:'right', marginRight:'5px'}}
                    onClick={()=>{
                      sessionStorage.removeItem('login')
                      // eslint-disable-next-line no-restricted-globals
                      location.reload()
                      
                    }}>로그아웃</Button>
                </Card.Body>
              </Card>     
      )
    }

    function NoLoginProfile() {
      return(
        <Card style={{ width: '100%' }}>
        {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
        <Card.Body>
          <Card.Title>아직 로그인하지 않았습니다.</Card.Title>
          <Card.Text>
            <Link to='/login' style={{marginRight:'10px'}}>로그인</Link>
            <Link to='/register'>회원가입</Link>
          </Card.Text>
          
        </Card.Body>
      </Card>     

      )

    }
}

export default Profile